import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/bb74bfb/node_modules/@undataforum/gatsby-theme-base/src/components/mdx-page.js";
import MdxLayout from '../../src/components/mdx-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = MdxLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <p>{`This website provides a space for the global statistical community to share
guidance, recommended actions, tools and best practices to ensure the
operational continuity of data collection programmes by National Statistical
Offices, and to address issues of open and timely access to critical data needed
by governments and all sectors of society to respond to the global COVID-19
crisis.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      